const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/analyze/roi-suite.$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/analyze/roi-suite/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "ROI Suite",
      description: "Page title for the ROI Suite analytics page"
    })
  }
});